export enum RecurrenceEditingMode {
  'none',
  'currentOccurrence',
  'currentOccurrenceAndFollowing',
  'allOccurrences',
}

export class RecurrenceEditingHelper {
  static humanize(mode: RecurrenceEditingMode) {
    switch (mode) {
      case RecurrenceEditingMode.none:
        return 'Jedna událost'
      case RecurrenceEditingMode.currentOccurrence:
        return 'Jedna událost ze série'
      case RecurrenceEditingMode.currentOccurrenceAndFollowing:
        return 'Tato a následující události ze série'
      case RecurrenceEditingMode.allOccurrences:
        return 'Celá série'
      default:
        return ''
    }
  }

  humanize(mode: RecurrenceEditingMode) {
    return RecurrenceEditingHelper.humanize(mode)
  }
}
